import Background from 'formstone/jquery/background';
import Checkpoint from 'formstone/jquery/checkpoint';
import Lightbox from 'formstone/jquery/lightbox';
import Mediaquery from 'formstone/jquery/mediaquery';
import Navigation from 'formstone/jquery/navigation';
import Swap from 'formstone/jquery/swap';

window.Debounce = (callback, timeout) => {
  let timer = null;

  return (...args) => {
    window.clearTimeout(timer);

    timer = window.setTimeout(() => {
      callback(...args);
    }, timeout);
  };
};

window.SiteReady(($) => {
  console.log('Init: Main Site');

  let $window = $(window);
  let $body = $('body');


  // Tables

  $('.wp-block-table').find('table').wrap('<div class="table_wrapper"></div>');


  // Scroll

  let newScroll = -1;
  let lastScroll = 0;
  let newShift = -1;
  let lastShift = 100;

  function onScroll() {
    newScroll = $window.scrollTop();
    newShift = newScroll;
  }

  function onRAF() {
    if (newScroll != lastScroll) {
      let scrollDir = (newScroll < lastScroll) ? 'up' : 'down';

      if (newScroll > 0) {
        $body.addClass('scrolled');
      } else {
        $body.removeClass('scrolled');
      }

      // if (newScroll > 200) {
      //   if (scrollDir == 'down') {
      //     if (newShift - lastShift > 80) {
      //       $body.addClass('shifted');

      //       lastShift = newShift;
      //     }
      //   } else {
      //     if (lastShift - newShift > 80) {
      //       $body.removeClass('shifted');

      //       lastShift = newShift;
      //     }
      //   }
      // }

      lastScroll = newScroll;
    }

    window.requestAnimationFrame(onRAF);
  }

  $window.on('scroll', onScroll);
  window.requestAnimationFrame(onRAF);

  onScroll();


  // // Desktop Nav

  // $('.js-header_menu_handles li:not(.no_dropdown), .js-header_menu').on('mouseenter focusin', (e) => {
  //   let id = $(e.currentTarget).attr('id')
  //               .replace('menu-item-', '')
  //               .replace('header_menu-', '');

  //   closeMenus();
  //   openMenu(id);
  // });

  // $('.js-header_menu_handles').on('mouseleave focusout', (e) => {
  //   closeMenus();
  // });

  // function openMenu(id) {
  //   $('#menu-item-' + id).addClass('open');
  //   $('.js-header_menu-' + id).addClass('open');
  //   $('.js-header').addClass('open');
  //   $('.js-header_expand').attr('aria-hidden', null);
  // }

  // function closeMenus() {
  //   $('.js-header_menu_handles li, .js-header_menu').removeClass('open');
  //   $('.js-header').removeClass('open');
  //   $('.js-header_expand').attr('aria-hidden', 'true');
  // }


  // Mobile Nav

  $('.js-mobile_menu .current_page_item').parents('.nav_item').addClass('current-menu-ancestor');

  $('.js-mobile_menu .menu > .menu-item-has-children > a').each((index, el) => {
    let $link = $(el);
    let active = ($link.parent('li').hasClass('current-menu-ancestor') || $link.parent('li').hasClass('current_page_item'));
    let html = '';
    let linkClass = 'js-nav_toggle_' + index;

    html += '<span class="toggle_handle js-swap js-nav_toggle';
    if (active) {
      linkClass += ' fs-swap-active';
      html += ' fs-swap-active';
    }
    html += '" data-swap-target=".js-nav_toggle_' + index + '"';
    if (active) {
      html += ' data-swap-active="true"';
    }
    // html += ' data-swap-options="{&quot;maxWidth&quot;:&quot;979px&quot;}"';
    html += '></span>';

    $link.append(html).next('ul').addClass(linkClass);
  });

  $('.js-mobile_menu').on('navigation:open', function() {
    $('.js-mobile_menu').scrollTop(0);
  });


  // Videos

  function initVideoPlayer($target) {
    let player = $target.data('videoPlayer');

    if (typeof player == 'undefined') {
      let $iframe = $target.find('.js-video_player');
      let src = $iframe.attr('src');

      if (typeof src == 'undefined') {
        $iframe.attr('src', $iframe.data('src'));
      }

      $target.data('videoPlayer', $iframe);
    }
  }

  // if ($('.js-video_modal, .js-video_swap').length > 0 && $('script[src*="youtube.com/iframe_api"]').length == 0) {
  //   $('head').append('<script src="//www.youtube.com/iframe_api"></script>');
  // }

  // let originalYouTubeCallback = window.onYouTubeIframeAPIReady || null; // Fixes background race condition

  // window.onYouTubeIframeAPIReady = () => {
  //   if (typeof originalYouTubeCallback == 'function') {
  //     originalYouTubeCallback();
  //   }
  // }

  // $('.js-video_swap, .js-video_modal').each((index, el) => {
  //   initVideoPlayer($(el));
  // });

  // $('.js-video_swap, .js-video_modal').on('swap:activate', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $iframe = $target.find('.js-video_player');

  //   $iframe[0].contentWindow.postMessage(JSON.stringify({method:"play"}), '*');
  //   // $iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

  //   let windowWidth = window.innerWidth;

  //   if (windowWidth < 740) {
  //     document.documentElement.requestFullscreen();
  //   }
  // }).on('swap:deactivate', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $iframe = $target.find('.js-video_player');


  //   $iframe[0].contentWindow.postMessage(JSON.stringify({method:"pause"}), '*');
  //   // $iframe[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');

  //   if (document.fullscreenElement != null) {
  //     document.exitFullscreen();
  //   }
  // });


  // Filter Groups

  // $('.js-filter_group .js-filter_button').on('click', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   // let $select = $parent.find('.js-filter_select');
  //   let $items = $parent.find('.js-filter_item');
  //   let active = $target.data('filter');

  //   $buttons.removeClass('active');
  //   $target.addClass('active');

  //   if (active == 'all') {
  //     $items.show();
  //   } else {
  //     $items.hide().filter('[data-filter="' + active + '"]').show();
  //   }
  // });

  // $('.js-filter_group .js-filter_select').on('change', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   let active = $target.val();

  //   $buttons.filter('[data-filter="' + active + '"]').trigger('click');
  // });



  // Filters

  // $('.js-jump_form').on('submit', (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  // });

  // $('.js-jump_select').on('change', (e) => {
  //   let val = $(e.currentTarget).val();

  //   window.location.href = val;
  // });

  $('.js-filter_form select').on('change', (e) => {
    let $target = $(e.currentTarget);
    let label = $target.find('option:selected').data('label');

    $target[0].dataset.selected = $target.val();
    $target.next('.js-filter_spacer').text(label);

    $target.parents('form').submit();
  });


  // Scroll Next

  $('.js-scroll_next').on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    let $parent = $(e.currentTarget).parents('.js-scroll_next_parent');
    // let $next = $parent.next();

    // if ($next.length) {
    //   window.scrollToElement($next);
    // }

    let height = $parent.outerHeight() - (window.scrollY - $parent[0].offsetTop);

    window.scrollDistance(height);
  });

  //  Hoverboard
  let $hoverboard = $('.hoverboard');
  let $footer = $('footer');

  function checkHoverboard() {
    let scrollTop = $window.scrollTop();
    let windowHeight = $window.height();
    let footerTop = $footer.offset().top;

    // if (scrollTop > windowHeight * 0.8) {
    if (scrollTop > 100) {
      $hoverboard.addClass('visible');
    } else {
      $hoverboard.removeClass('visible');
    }

    if (scrollTop + windowHeight >= footerTop) {
      $hoverboard.removeClass('visible');
    }
  }

  if ($hoverboard.length) {
    $window.on('scroll', checkHoverboard).trigger('scroll');
  }


  // // Search Modal

  // $('.js-search_modal').on('swap:activate', (e) => {
  //   let $target = $(e.currentTarget);

  //   setTimeout(() => {
  //     $target.find('input[type="text"]').first().focus();
  //   }, 50);
  // });


  // // Action bar resize

  // $(window).on('resize', (e) => {
  //   let $bars = $('.action_bar');

  //   $bars.each((index, el) => {
  //     let height = el.firstChild.offsetHeight;

  //     el.style.setProperty('--action_bar_height', height + 'px');
  //   })
  // }).trigger('resize');


  // Plugins

  $('.js-navigation').navigation();
  $('.js-background').background();
  $('.js-swap').swap();
  $('.js-lightbox').lightbox();
  // $('.js-tabs').tabs();

  $('.js-checkpoint, [data-checkpoint-animation]').checkpoint({
    offset: '100px',
    reverse: true
  });

  if (typeof window.loadFooterPost != 'undefined') {
    let current = window.currentPost;
    let type = window.loadFooterPost;
    let data = localStorage.getItem( 'theme-filtered-' + type );

    if (data) {
      let json = JSON.parse(data);
      let index = json.indexOf(current) + 1;

      if ( index >= json.length ) {
        index = 0;
      }

      $.ajax({
        url: window.THEME_OPTIONS.ajax_url,
        type: 'get',
        data: {
          action: 'get_footer_callout',
          type: type,
          post: json[ index ],
          cache: true,
        },
        success: function(response, status, jqXHR) {
          $('.js-footer').after(response);
        },
        error: function() {
          console.log(arguments);
        }
      });

    }
  }

  // Forms

  $(document).on('gform_confirmation_loaded gform_page_loaded', function(e, form) {
    window.scrollToElement('#gf_' + form);
  });

});